import styled from 'styled-components';

import { FONT_WEIGHT_MEDIUM } from 'styles/theme/textStyles';

export const LabelSmall = styled.label`
  font-family: ${({ theme }) => theme.textStyles.base.fontFamily};
  font-size: ${({ theme }) => theme.textStyles.labelSmall.fontSize};
  line-height: ${({ theme }) => theme.textStyles.labelSmall.lineHeight};
`;
export const LabelSmallBold = styled(LabelSmall)`
  font-weight: ${FONT_WEIGHT_MEDIUM};
`;

export const Label = styled.label<{
  fontSize?: string;
  htmlFor?: string;
}>`
  font-family: ${({ theme }) => theme.textStyles.base.fontFamily};
  font-size: ${({ fontSize, theme }) => fontSize ?? theme.textStyles.label.fontSize};
  line-height: ${({ theme }) => theme.textStyles.label.lineHeight};
`;
export const LabelBold = styled(Label)`
  font-weight: ${FONT_WEIGHT_MEDIUM};
`;

export const Body = styled.p<{
  fontWeight?: string;
  color?: string;
}>`
  font-family: ${({ theme }) => theme.textStyles.base.fontFamily};
  font-size: ${({ theme }) => theme.textStyles.h3.fontSize};
  line-height: ${({ theme }) => theme.textStyles.h3.lineHeight};
  font-weight: ${({ fontWeight }) => fontWeight || 'normal'};
  color: ${({ color }) => color};
`;
export const BodyBold = styled(Body)`
  font-weight: ${FONT_WEIGHT_MEDIUM};
`;

export const BodySmall = styled(Body)`
  font-size: ${({ theme }) => theme.textStyles.bodySmall.fontSize};
  line-height: ${({ theme }) => theme.textStyles.bodySmall.lineHeight};
`;

export const BodySmallBold = styled(BodySmall)`
  font-weight: ${FONT_WEIGHT_MEDIUM};
`;

// Inline emphasis at the app's medium weight. A bare <b> or <strong> renders at 700.
export const Strong = styled.span`
  font-weight: ${FONT_WEIGHT_MEDIUM};
`;

export const H3 = styled.h3`
  font-family: ${({ theme }) => theme.textStyles.base.fontFamily};
  font-weight: ${FONT_WEIGHT_MEDIUM};
  font-size: ${({ theme }) => theme.textStyles.h3.fontSize};
  line-height: ${({ theme }) => theme.textStyles.h3.lineHeight};
  margin: 0px;
`;
export const H2 = styled.h2`
  font-family: ${({ theme }) => theme.textStyles.base.fontFamily};
  font-weight: ${({ theme }) => theme.textStyles.h2.fontWeight};
  font-size: ${({ theme }) => theme.textStyles.h2.fontSize};
  line-height: ${({ theme }) => theme.textStyles.h2.lineHeight};
  margin: 0px;
`;
export const H1 = styled.h1`
  font-family: ${({ theme }) => theme.textStyles.base.fontFamily};
  font-weight: ${({ theme }) => theme.textStyles.h1.fontWeight};
  font-size: ${({ theme }) => theme.textStyles.h1.fontSize};
  line-height: ${({ theme }) => theme.textStyles.h1.lineHeight};
  margin: 0px;
`;
